import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/auth";
import { api } from "@/api";
import StorePage from "@/pages/StorePage_gen4";
import PanduanMacPage from "@/pages/PanduanMacPage";
import MitraPage from "@/pages/MitraPage";
import LoginPage from "@/pages/LoginPage_gen2";
import AdminPage from "@/pages/AdminPage_gen3";

function Gate({ loginProps, mode }) {
  const { user } = useAuth();
  if (user === null) return <div className="center-note" data-testid="auth-loading">Memuat...</div>;
  if (!user) return <LoginPage {...loginProps} />;
  return <AdminPage mode={mode} />;
}

function SuperadminArea() {
  return (
    <AuthProvider tokenKey="superadmin" expectRole="superadmin">
      <Gate mode="super" loginProps={{ title: "Login Admin Utama", subtitle: "Kelola semua toko, admin, dan reseller dari satu tempat.", variant: "super" }} />
    </AuthProvider>
  );
}

function StoreAdminArea() {
  const { slug } = useParams();
  const s = slug.toLowerCase();
  // Toko Utama dikelola akun superadmin (tidak ada admin terpisah) -> izinkan login superadmin di /toko/{slug}/admin
  const [mainSlug, setMainSlug] = useState(localStorage.getItem("main-slug"));
  useEffect(() => {
    api.get("/public/main-slug").then((r) => { localStorage.setItem("main-slug", r.data.slug); setMainSlug(r.data.slug); }).catch(() => {});
  }, []);
  if (!mainSlug) return <div className="center-note">Memuat...</div>;
  return (
    <AuthProvider tokenKey={`admin:${s}`} expectRole="admin" slug={s} allowSuper={mainSlug === s}>
      <Gate mode="store" loginProps={{ title: "Login Admin Toko", subtitle: `Toko /toko/${s} — kelola voucher, harga, reseller, dan pesanan.`, backTo: `/toko/${s}`, backLabel: "Kembali ke halaman toko", slug: s }} />
    </AuthProvider>
  );
}

function MainStoreRedirect() {
  // Selalu ambil slug Toko Utama dari server; cache localStorage hanya cadangan bila server gagal (cache basi -> "Toko tidak ditemukan")
  const [slug, setSlug] = useState(null);
  useEffect(() => {
    api.get("/public/main-slug").then((r) => { localStorage.setItem("main-slug", r.data.slug); setSlug(r.data.slug); })
      .catch(() => setSlug(localStorage.getItem("main-slug") || ""));
  }, []);
  if (!slug) return <div className="center-note">Memuat...</div>;
  return <Navigate to={`/toko/${slug}`} replace />;
}

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainStoreRedirect />} />
          <Route path="/toko/:slug" element={<StorePage />} />
          <Route path="/mitranet/mitra/:slug" element={<MitraPage />} />
          <Route path="/toko/:slug/admin" element={<StoreAdminArea />} />
          <Route path="/panduan-mac" element={<PanduanMacPage />} />
          <Route path="/superadmin" element={<SuperadminArea />} />
          <Route path="/admin" element={<Navigate to="/superadmin" replace />} />
          <Route path="/login" element={<Navigate to="/superadmin" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </>
  );
}
